import React, { JSX, useState } from "react";
import { Box, Typography } from "@mui/material";
import List from "../../../components/List";
import { convertADtoBS } from "../../../components/Calendar/functions/calendarFunctions";
import { clientFullNameSelector } from "../../../reducers/client";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { BillingPackage } from "../../../interfaces/BillingPackages";
import BillingPackageEditPanel from "./BillingPackageEditPanel";
import BillingPackageStatusChip from "./BillingPackageStatusChip";
import { fetchBillingPackages } from "../../../slices/billPackageSlice";
import BillingPackageSearch from "./BillingPackageSearch";
import { Client } from "../../../interfaces/ClientInterface";

const BillingPackagesList = (): JSX.Element => {
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const billingPackages = useAppSelector((state) => state.billingPackages.collection);
  const [selectedPackage, setSelectedPackage] = useState<BillingPackage | null>(null);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(fetchBillingPackages(selectedClient?.id));
  }, [selectedClient?.id]);

  return (
    <Box height="100%" minWidth={900}>
      <Box sx={{ py: 1 }}>
        <BillingPackageSearch
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
        />
      </Box>
      <List<BillingPackage>
        withoutSearch
        hideCreateButton
        data={billingPackages}
        rowHeight={50}
        onRowClick={(row) => {
          if (selectedPackage?.id !== row.id) {
            setSelectedPackage(row);
          } else {
            setSelectedPackage(null);
          }
        }}
        columns={[
          {
            key: "createdDate",
            label: "Created Date",
            formatter: (row) => (
              <Typography>{convertADtoBS(new Date(row.created_at)).formatted4}</Typography>
            ),
            sortable: true
          },
          {
            key: "clientName",
            label: "Client Name",
            formatter: (row) => <Typography>{clientFullNameSelector(row.client)}</Typography>
          },
          {
            key: "totalAmount",
            label: "Total Amount",
            formatter: (row) => <Typography>{row.totalAmount}</Typography>
          },
          {
            key: "status",
            label: "Status",
            formatter: (row) => <BillingPackageStatusChip status={row.status} />
          },
          {
            key: "updatedAt",
            label: "Updated Date",
            formatter: (row) => (
              <Typography>{convertADtoBS(new Date(row.updated_at)).formatted4}</Typography>
            ),
            sortable: true
          }
        ]}
        automation="billingPackagesList"
      />
      {selectedPackage?.id && (
        <BillingPackageEditPanel
          onClose={() => {
            setSelectedPackage(null);
          }}
          data={selectedPackage}
        />
      )}
    </Box>
  );
};

export default BillingPackagesList;
